<template>
  <div class="mosaic" :style="mosaicGridStyle">
    <MosaicPiece 
      v-for="n in pieces"
      :key="n"
      :state="piecesStates[n]"
      :records="records"
    />
  </div>
</template>

<script>
import MosaicPiece from './MosaicPiece.vue'
import { getRandom } from '../../assets/js/utils.js'

export default {
  name: 'Mosaic',
  components: {
    MosaicPiece,
  },
  data(){
    return {
      containerWidth: 0,
      containerHeight: 0,
      rows: 0,
      w: 0,
      h: 0,
      mosaicGridStyle: {
        display: 'grid',
        gridTemplateColumns: "repeat(10, 1fr)",
        gridTemplateRows: null,
        overflowY: 'hidden',
      },
      pieces: 0,
      queueLength: 20,
      piecesStates: [],
    }
  },
  computed: {
    records: function(){return this.$store.getters.getRecords.map(record => record.metadata.code)},
  },
  mounted() {
    this.containerWidth = this.$el.clientWidth;  
    this.containerHeight = this.$el.clientHeight;  
    this.w = this.containerWidth / 10;
    this.h = this.w * 4 / 5;
    this.rows = Math.ceil(this.containerHeight / this.h);
    this.mosaicGridStyle.gridTemplateRows = `repeat(${this.rows}, ${this.h}px)`;
    this.pieces = 10 * this.rows;
    this.queueLength = Math.floor(this.pieces * .5);
    for (let i = 0; i < this.pieces; i++) {
      this.piecesStates.push({state: null});
    }
    const candidates = [...Array(this.pieces).keys()];
    const startingSet = getRandom(candidates, this.queueLength);
    startingSet.forEach(n => {
      this.piecesStates[n].state = Math.random() > .5 ? 'black' : 'img';
    });
    setInterval(function(){
      this.switch();
    }.bind(this), 50);
  },
  methods: {
    switch() {
      const n = Math.floor(Math.random() * this.pieces);
      this.piecesStates[n].state = Math.random() < .5 ? null : Math.random() < .5 ? 'img' : 'black';
    }
  }  
}
</script>

<style scoped>
  .mosaic {
    width: 100%;
    height: 100%;
  }
</style>